<template>
    <div style="height: 100%;">
      <my-header>
        选择题
      </my-header>
      <video ref="input_video" width="100%" height="100%" style="display: none;"></video>
      <template v-if="questions.length">
        <van-cell style="font-size: 3rem; line-height: 3rem;">
          {{questionIndex + 1}}.{{questions[questionIndex]['title']}}
        </van-cell>
        <van-cell v-for="(option, key) in questions[questionIndex]['options']" :key="key">
          {{String.fromCharCode(65 + key)}}：{{option}}
        </van-cell>
      </template>
      <div style="position:relative;">
        <div class="question">
          <!--<van-row style="width: 100%;">
            <van-col span="24" style="text-align: center; width: 100%;">
              1+1=?
            </van-col>
          </van-row>-->
<!--          <template v-if="questions.length">
            <van-grid :column-num="questions[questionIndex]['options'].length" :gutter="50">
              <van-grid-item v-for="(option, key) in questions[questionIndex]['options']" icon="photo-o" :key="key" >
                <div style="opacity: 100%; background-color: transparent;">
                  {{String.fromCharCode(65 + key)}}
                </div>
              </van-grid-item>
            </van-grid>
          </template>-->

<!--          <van-row style="width: 100%;" gutter="100">
            <van-col span="12">
              <van-button plain hairline type="primary">1</van-button>
            </van-col>
            <van-col span="12">
              <van-button plain hairline type="primary">2</van-button>
            </van-col>
          </van-row>-->
          <van-row>
            <van-col v-if="waiting" span="24">
              {{timeout}}
            </van-col>
          </van-row>
        </div>
        <canvas
            class="output_canvas"
            ref="output_canvas"
            :width="width"
            :height="height"
        ></canvas>
      </div>
    </div>
</template>
<script>
import { Hands, HAND_CONNECTIONS } from "@mediapipe/hands";
import { Camera } from "@mediapipe/camera_utils";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import { Field, Button, Toast, Cell, CellGroup, Row, Col, Grid, GridItem, Dialog } from 'vant'
import { calcAgentBy2DPoint } from '@/utils/mediapipe'
import { getList } from '@/api/question'

export default {
  name: "HandModel",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button
  },
  data: function() {
    return {
      camera: null,
      number: null,
      ctx: null,
      width: null,
      height: null,
      timeout: 3,
      waiting: false,
      timer: null,
      rightCount: 0,
      leftCount: 0,
      handsImage: '',
      questions: [],
      questionIndex: 0,
    };
  },
  computed: {
    inputVideo() {
      return this.$refs.input_video;
    },
  },
  mounted() {
    this.ctx = this.$refs.output_canvas.getContext("2d");
    this.getQuestions().then(res => {
      this.init();
    })
  },
  methods: {
    init() {
      this.handsImage = new Image();
      this.handsImage.src = require('@/assets/hands.png');
      window.requestAnimationFrame(this.hands);
    },
    hands() {
      const hands = new Hands({
        locateFile: (file) => {
          // console.log(file)
          // return `http://localhost:8080/static/@mediapipe/hands@0.4.1646424915/${file}`;

          // 只有这个固定版本正常，更高的版本都报错，暂时不知道原因
          return `/static/@mediapipe/hands@0.3.1632795355/${file}`;
          return `https://cdn.jsdelivr.net/npm/@mediapipe/hands@0.3.1632795355/${file}`;
        },
      });
      hands.setOptions({
        maxNumHands: 1,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
      });
      hands.onResults(this.onResults);

      this.camera = new Camera(this.inputVideo, {
        onFrame: async () => {
          await hands.send({ image: this.inputVideo });
        },
      });
      this.camera.start();
    },
    onResults(results) {
      this.width = results.image.width;
      this.height = results.image.height;
      this.ctx.save();
      this.ctx.clearRect(0, 0, results.image.width, results.image.height);
      // 下面两句翻转
      this.ctx.translate(results.image.width, 0);
      this.ctx.scale(-1, 1);
      // console.log(results.image)
      this.ctx.drawImage(
          results.image,
          0,
          0,
          results.image.width,
          results.image.height
      );
      for (const landmarks of results.multiHandLandmarks) {
        drawConnectors(this.ctx, landmarks, HAND_CONNECTIONS, {
          color: "#00FF00",
          lineWidth: 5,
        });
        drawLandmarks(this.ctx, landmarks, {
          color: "#FF0000",
          lineWidth: 2,
        })
      }
      // this.findHands(results);
      this.ctx.restore();
      this.ctx.font = '100px STheiti, SimHei'
      this.ctx.fillStyle = "green"
      const optLen = this.questions[this.questionIndex]['options'].length
      const eachOptWidth = (this.width) / optLen
      for (const key in this.questions[this.questionIndex]['optionsData']){
        this.questions[this.questionIndex]['optionsData'][key]['position'] = {x: eachOptWidth*(key*1 + 0.5), y: this.height/2 }
        this.ctx.fillText(String.fromCharCode(65 + key*1), eachOptWidth*(key*1 + 0.5), this.height/2, 200)
      }

      if (results.multiHandLandmarks) {

        for (const landmarks of results.multiHandLandmarks) {
          const rigntPoint = { x: 0, y: landmarks[0]['y'] }
          var agent = calcAgentBy2DPoint(landmarks[0], landmarks[9], rigntPoint)
          agent = agent - 90
          // console.log(agent)
          this.checkHandsPosition(landmarks[9])
          const imageX = results.image.width - landmarks[9]['x'] * results.image.width
          const imageY = landmarks[9]['y'] * results.image.height
          this.ctx.translate(imageX , imageY)
          this.ctx.rotate(-agent * Math.PI / 180)
          this.ctx.translate(-imageX, -imageY)
          this.ctx.drawImage(
              this.handsImage,
              imageX-100,
              imageY-100,
              200,
              200
          )
          // this.ctx.translate(0 , 0)
          this.ctx.restore();

          // this.ctx.rotate(-50 * Math.PI / 180)
          break
        }
      }
      this.ctx.restore();
      this.ctx.save();
    },
    findHands(results, draw = true) {
      if (results.multiHandLandmarks) {
        for (const landmarks of results.multiHandLandmarks) {
          drawConnectors(this.ctx, landmarks, HAND_CONNECTIONS, {
            color: "#00FF00",
            lineWidth: 5,
          });
          if (draw) {
            drawLandmarks(this.ctx, landmarks, {
              color: "#FF0000",
              lineWidth: 2,
            })
          }
        }
      }
    },
    checkAnswer(answer) {
      if(answer === this.questions[this.questionIndex]['answer']) {
          this.rightCount++
        Toast('答对了')
      }else{
        Toast('答错了')
      }
      if(this.questions.length - 1 > this.questionIndex){
        this.questionIndex++
      }else{
        Dialog.alert({
          title: '答题结束',
          message: '答对了' + this.rightCount + '题',
        })
        .then(() => {
          this.rightCount = 0
          this.questionIndex = 0
        })
      }
    },
    checkHandsPosition(position){

      const options = this.questions[this.questionIndex]['optionsData']

      for (let i in options) {
        const width = Math.abs((position.x * this.width) - options[i]['position']['x'])
        const height = Math.abs((position.y * this.height) - options[i]['position']['y'])
        const tmpCounter = options[i]['counter']
        options[i]['counter'] = 0
        if(width < 80 && height < 80){
          options[i]['counter'] = tmpCounter + 1
          if(options[i]['counter'] > 50) {
            this.checkAnswer(i*1)
          }
        }
      }

    },
    getQuestions() {
      return getList({type: 'select'}).then(res => {
        for (let i in res.data.data){
          res.data.data[i]['optionsData'] = []
          for (let j in res.data.data[i]['options']){
            res.data.data[i]['optionsData'].push({counter: 0})
          }
        }
        this.questions = res.data.data
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.camera.stop()
    next()
  }
}
</script>

<style scoped>
.output_canvas {
  width: 100%;
  height: 100%;
}
.question{
  position: absolute;
  text-align: center;
  width: 100%;
  font-size: 5rem;
}
</style>
<style>
.van-grid-item__content{
  background-color: transparent;
}
</style>
